/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Vlt-icon-minus-bold': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.5 10.5h-21c-.9 0-1.5.6-1.5 1.5s.6 1.5 1.5 1.5h21c.9 0 1.5-.6 1.5-1.5s-.6-1.5-1.5-1.5z"/>'
  }
})
